import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="media-intro"]' },
  { target: '[data-tour="media-filters"]' },
  { target: '[data-tour="media-grid"]' }
];

export const FAMILY_MEDIA_TOUR_STEPS: TourStep[] = buildTourSteps('familyMedia', STEP_DEFS);

export const FAMILY_MEDIA_TOUR_STORAGE_KEY = 'wetree-family-media-tour-completed';

export function resolveFamilyMediaTourSteps(steps: TourStep[], hasMedia: boolean): TourStep[] {
  if (hasMedia) {
    return steps;
  }
  return steps.filter((step) => step.target !== '[data-tour="media-grid"]');
}
